




import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DPlayer from 'dplayer';
import 'dplayer/dist/DPlayer.min.css';

@Component
export default class SyPlayerMp4 extends Vue {
  @Prop() videoUrl!: string;
  @Prop() videoCover!: string;
  dp: any = null;
  mounted() {
    if (this.videoUrl !== undefined) {
      this.dp = new DPlayer({
        container: document.getElementById('dplayer'),
        theme: '#CA190E',
        video: {
          url: this.videoUrl,
          type: 'auto',
          pic: this.videoCover,
        },
      });
    }
  }
  @Watch('videoUrl')
  onVideoUrlChanged() {
    this.dp = new DPlayer({
      container: document.getElementById('dplayer'),
      theme: '#CA190E',
      video: {
        url: this.videoUrl,
        type: 'auto',
        pic: this.videoCover,
      },
    });
  }

}
